import { adminRequest } from './admin-api.js';
import type {
  PricingProfile,
  PricingRule,
  PricingContract,
  PricingSimulationRequest,
  PricingSimulationResponse,
  PricingSyncRequest,
  PricingSyncResponse,
} from '../types/index.js';

export const pricingAdminService = {
  async listProfiles(): Promise<PricingProfile[]> {
    return adminRequest('/admin/pricing/profiles', {
      method: 'GET',
    });
  },
  async createProfile(payload: Omit<PricingProfile, 'id' | 'createdAt' | 'updatedAt'>): Promise<PricingProfile> {
    return adminRequest('/admin/pricing/profiles', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
  async updateProfile(id: string, payload: Partial<PricingProfile>): Promise<PricingProfile> {
    return adminRequest(`/admin/pricing/profiles/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  },
  async listRules(profileId?: string): Promise<PricingRule[]> {
    const query = profileId ? `?profileId=${encodeURIComponent(profileId)}` : '';
    return adminRequest(`/admin/pricing/rules${query}`, { method: 'GET' });
  },
  async createRule(payload: Omit<PricingRule, 'id' | 'createdAt' | 'updatedAt'>): Promise<PricingRule> {
    return adminRequest('/admin/pricing/rules', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
  async updateRule(id: string, payload: Partial<PricingRule>): Promise<PricingRule> {
    return adminRequest(`/admin/pricing/rules/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  },
  async deleteRule(id: string): Promise<void> {
    await adminRequest(`/admin/pricing/rules/${id}`, { method: 'DELETE' });
  },
  async listContracts(customerExternalId?: string): Promise<PricingContract[]> {
    const query = customerExternalId ? `?customerExternalId=${encodeURIComponent(customerExternalId)}` : '';
    return adminRequest(`/admin/pricing/contracts${query}`, { method: 'GET' });
  },
  async createContract(payload: Omit<PricingContract, 'id' | 'createdAt' | 'updatedAt'>): Promise<PricingContract> {
    return adminRequest('/admin/pricing/contracts', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
  async updateContract(id: string, payload: Partial<PricingContract>): Promise<PricingContract> {
    return adminRequest(`/admin/pricing/contracts/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  },
  async deleteContract(id: string): Promise<void> {
    await adminRequest(`/admin/pricing/contracts/${id}`, { method: 'DELETE' });
  },
  async simulate(payload: PricingSimulationRequest): Promise<PricingSimulationResponse> {
    return adminRequest('/admin/pricing/simulate', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
  async syncContracts(payload: PricingSyncRequest): Promise<PricingSyncResponse> {
    return adminRequest('/admin/pricing/contracts/sync', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
};
